import { render, staticRenderFns } from "./OutboundDetails.vue?vue&type=template&id=6411bce7&"
import script from "./OutboundDetails.vue?vue&type=script&lang=js&"
export * from "./OutboundDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports